export const SMALL = 'small';
export const SMALL_2X = 'small_2x';
export const MEDIUM = 'medium';
export const MEDIUM_2X = 'medium_2x';
export const LARGE = 'large';
export const LARGE_2X = 'large_2x';
export const ORIGINAL = 'original';
